import React from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../Icons/AJGSoftwareW32.png';

const NavItem = ({ link, description, isImage }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const homeSections = ["", "OurServices", "Contact", "About"];

    const handleClick = (e) => {
        e.preventDefault();

        // Check if the link is a section on the main page (like OurServices)
        const isHomePageSection = homeSections.includes(link);

        if (location.pathname === "/" && isHomePageSection) {
            // OPTION A: We are already HOME, just scroll
            const targetId = link === "" ? "root" : link;
            const elm = document.getElementById(targetId);
            if (elm) {
                elm.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        } else {
            // OPTION B: We are on a subpage OR clicking a deep-link (Software/Robotics)
            // If it's a home section, go to "/" with the hash
            const targetPath = isHomePageSection ? `/#${link}` : `/${link}`;
            navigate(targetPath);
            
            // If navigating to home hash from a subpage, we handle the scroll 
            // after a tiny delay to allow the Main component to mount
            if (isHomePageSection && location.pathname !== "/") {
                setTimeout(() => {
                    const elm = document.getElementById(link);
                    if (elm) elm.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
        }
    };

    return (
        <div id="nav-links" className='column'>
            <a href={`/${link}`} onClick={handleClick} style={{ cursor: 'pointer' }}>
                {isImage ? description : description}
            </a>
        </div>
    );
};

export const NavBar = () => {
    return (
        <div className="nav-class">
            <header id="nav-content" className="App-header">
                <div id="nav-row" className='row'>
                    <NavItem 
                        link="" 
                        isImage={true} 
                        description={<img src={logo} alt='Software consultancy Cheshire'/>} 
                    />
                    <NavItem link="OurServices" description="Our Services" />
                    <NavItem link="Services/SoftwareDevelopment" description="Software Development" />
                    <NavItem link="Services/RoboticsAutomation" description="Robotics & Automation" />
                    <NavItem link="About" description="About AJG Software" />
                    <NavItem link="Contact" description="Contact" />
                </div>
            </header>
        </div>
    );
}

export default NavBar;